import { Injectable } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { DateRange, MatDateRangeSelectionStrategy } from '@angular/material/datepicker';

@Injectable()
export class CalendarRangeService implements MatDateRangeSelectionStrategy<Date> {
  // start Date
  start!: Date;

  // range of dates to selected
  public range!: string;

  constructor(private readonly dateAdapter: DateAdapter<Date>) {}

  /**
   * Function to select dates between particular dates
   **/
  selectionFinished(date: Date, currentRange: DateRange<Date>) {
    let { start, end } = currentRange;
    // If startDate is not previously selected or
    // If current selected date is less than or equal to previously selected start date or
    // If user clicks on new date with previous selected start and end date,
    // then set the startDate to new date and endDate to null.
    if (
      start == null ||
      this.dateAdapter.compareDate(date, start) <= 0 ||
      (start && end)
    ) {
      start = date;
      end = null;
    } else if (end == null) {
      const maxDate = this.dateAdapter.addCalendarDays(start, +this.range);
      end = date ? this.getMinDate(date, maxDate) : null;
    }

    return new DateRange<Date>(start, end);
  }

  /**
   * Function to show preview of dates selected in datepicker
   **/
  createPreview(activeDate: Date | null, currentRange: DateRange<Date>): DateRange<Date> {
    if (currentRange.start && !currentRange.end) {
      const maxDate = this.dateAdapter.addCalendarDays(currentRange.start, +this.range),
        rangeEnd = activeDate ? this.getMinDate(activeDate, maxDate) : null;

      return new DateRange(currentRange.start, rangeEnd);
    }

    return new DateRange<Date>(null, null);
  }

  /**
   * Returns minimum of two dates.
   *
   * @param {Date} date1
   * @param {Date} date2
   * @returns {Date}
   */
  getMinDate = (date1: Date, date2: Date) => (date1 > date2 ? date2 : date1);
}
